<template lang="pug">
#content-floating-toolbar.btn-group(
  data-cy='sofia-contextual' 
  v-show='visible' 
  :style="{ top: y + 'px', left: x + 'px' }"
)
  button.btn.btn-primary(
    type='button'
    data-cy='sofia-analysis'
    :title="t('components.sofia.brand.title')"
    @click='onClickSofia'
    v-show='sofiaEnabled'
  )
    .sofia_float_icon
      sofia-svg
    span {{ t("components.sofia.brand.title") }}
  button.btn.btn-primary(
    type='button'
    :title="t('components.sofia.wrapper.copy')"
    data-cy='sofia-copy'
    @click='onClickCopy'
  )
    i.fas.fa-copy.fa-md(aria-hidden='true')
    span {{ t("components.sofia.wrapper.copy") }}
</template>

<script>
import mixins from "common/mixins"
import sofiaSvg from '../../../assets/images/common/sofia.svg'

export default {
  name: 'sofia-contextual-menu-vue',
  props: {
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    visible: { type: Boolean, default: true },
    sofiaEnabled: { type: Boolean, default: true }
  },
  components: {
    'sofia-svg': sofiaSvg
  },
  mixins: [mixins.translate],
  methods: {
    onClickSofia(){
      this.$emit('clickSofia')
    },
    onClickCopy(){
      this.$emit('clickCopy')
    }
  },
}
</script>
